import axios from 'axios'
import { Constants } from '../common'
import { clearAuthTokens } from './authTokens'
import { getClerkSessionToken } from './clerkSession'

const axiosQuery = axios.create({
  baseURL: Constants.API_URL,
  withCredentials: true,
  headers: {
    Accept: '*/*',
    'Content-Type': 'application/json',
  },
})

axiosQuery.interceptors.request.use(
  async (config) => {
    config.withCredentials = true
    const token = await getClerkSessionToken()
    if (token) {
      config.headers = {
        ...(config.headers || {}),
        Authorization: `Bearer ${token}`,
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

axiosQuery.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config
    const status = error?.response?.status
    if (!originalRequest || status !== 401 || originalRequest._retry) {
      return Promise.reject(error)
    }

    originalRequest._retry = true
    clearAuthTokens()
    return Promise.reject(error)
  },
)

export default axiosQuery
